<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="content-chapter2" id="_idParaDest-4"><a href="#/BlackAndResilient3#_idTextAnchor001">Part I: <br/>His Name Is Trayvon<span id="_idTextAnchor029"></span> </a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BlackAndResilient9.vue?07b3035b